const initialState = {
    notifications: [],
    loading: false,
    error: null,
};

export default function notificationReducer(state = initialState, action) {
    switch (action.type) {
        case 'GET_NOTIFICATIONS_LOADING':
            return { ...state, loading: true, error: null };
        case 'GET_NOTIFICATIONS_SUCCESS':
            return {
                ...state,
                loading: false,
                notifications: action.payload.items || action.payload,
                error: null
            };
        case 'GET_NOTIFICATIONS_FAILURE':
            return { ...state, loading: false, error: action.payload };

        case 'NOTIFICATION_DELETE_REQUEST':
            return { ...state, error: null };
        case 'NOTIFICATION_DELETE_SUCCESS':
            return {
                ...state,
                notifications: state.notifications.filter(
                    notification => notification.id !== action.payload
                ),
                error: null
            };
        case 'NOTIFICATION_DELETE_FAILURE':
            return { ...state, error: action.error };

        case 'NOTIFICATION_STATUS_UPDATE_REQUEST':
            return { ...state, error: null };

        case 'NOTIFICATION_STATUS_UPDATE_SUCCESS':
            return {
                ...state,
                loading: false,
                notifications: action.payload.items || action.payload,
                error: null
            };

        case 'NOTIFICATION_STATUS_UPDATE_FAILURE':
            return { ...state, error: action.error };
    

        default:
            return state;
    }
}
